import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { GetStakingBannerInfoQuery } from "@gql/staking";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { AccountService } from "@modules/account/services/account.service";
import { Tradable } from "@models/interfaces/tradable";
import { convertTradableToFiat } from "@helpers/tradable-convert";
import { StakingRewardAmountModel } from "@modules/staking/domain/entities/staking-overview-state.model";
import { StakingBannerState } from "@modules/staking/domain/entities/staking-banner-state.model";

export class StakingBannerStateAdapter extends BaseAdapter<GetStakingBannerInfoQuery, StakingBannerState> {
	public constructor(
		private readonly tradableListService: TradableListService,
		private readonly accountService: AccountService
	) {
		super();
	}

	public adapt(item: GetStakingBannerInfoQuery): StakingBannerState {
		const highestYield = item.assetConfig.assets[0].yearlyInterest;
		const notStaking = item.balances.length === 0;
		const rewards: StakingRewardAmountModel[] = item.lifetimeRewards.map((item) => ({
			assetId: item.asset.assetId,
			assetAmount: item.rewardsAmount.asset.value
		}));
		const totalAmount: number = this.getTotalAmount(rewards);

		return {
			hasError: false,
			init: true,
			notStakingCurrently: notStaking,
			highestYield: highestYield,
			stakedCoins: item.balances.length,
			totalLifetimeRewards: totalAmount,
			buttonKey: item.balances.length === 0 ? "portfolio_cross_selling_staking_start_staking" : "view_more",
			stakedItemsId: item.balances.map((item) => item.asset.assetId),
			assetConfig: item?.assetConfig
		};
	}

	private getTotalAmount(amounts: StakingRewardAmountModel[]): number {
		return amounts
			.map((item) => {
				const tradable: Tradable = this.tradableListService.getItemById(item.assetId);
				return +convertTradableToFiat(tradable, +item.assetAmount, this.accountService.getDefaultFiat());
			})
			.reduce((sum: number, balance: number) => sum + balance, 0);
	}
}
